module.exports = __webpack_public_path__ + "img/logo-main-light.87046d66.svg";